import gql from 'graphql-tag';

/**
 * Queries against the status (monitoring) API — see content-status/api/api.graphql.
 *
 * These are global aggregates, not organization-scoped data: the API returns counts across every
 * organization and authorization gates the field rather than the rows. The dashboard is reachable
 * only under the castlabs_cpteam organization, which is the membership whose policies grant these
 * actions.
 */

const PROCESS_COUNTS_FIELDS = gql`
  fragment ProcessCountsFields on ProcessCounts {
    started
    succeeded
    failed
    aborted
    in_progress
    failure_rate
    avg_duration_ms
    stale_in_progress
  }
`;

export const GET_PROCESS_STATS = gql`
  query GetProcessStats($input: ProcessStatsInput!) {
    process_stats(input: $input) {
      api
      window
      window_start
      window_end
      totals { ...ProcessCountsFields }
      by_action {
        action
        counts { ...ProcessCountsFields }
      }
    }
  }
  ${PROCESS_COUNTS_FIELDS}
`;

export const GET_PROCESS_FAILURES = gql`
  query GetProcessFailures($input: ProcessFailuresInput!) {
    process_failures(input: $input) {
      next_token
      failures {
        id
        action
        message
        start_date
        end_date
      }
    }
  }
`;

export const GET_PUBLISH_STATS = gql`
  query GetPublishStats($input: PublishStatsInput!) {
    publish_stats(input: $input) {
      window
      window_start
      window_end
      methods {
        state_machine
        method
        started
        succeeded
        failed
        aborted
        in_progress
        failure_rate
        avg_duration_ms
      }
    }
  }
`;

export const GET_PUBLISH_FAILURES = gql`
  query GetPublishFailures($input: PublishFailuresInput!) {
    publish_failures(input: $input) {
      next_token
      failures {
        execution
        state_machine
        start_date
        end_date
      }
    }
  }
`;

export const GET_VTK_JOB_STATS = gql`
  query GetVtkJobStats($input: VtkJobStatsInput!) {
    vtk_job_stats(input: $input) {
      collected_at
      window_start
      window_end
      total
      by_status {
        status
        status_text
        count
      }
      by_organization {
        organization_urn
        total
        by_status {
          status
          status_text
          count
        }
      }
    }
  }
`;

export const GET_INDEX_STATS = gql`
  query GetIndexStats($input: IndexStatsInput!) {
    index_stats(input: $input) {
      alias
      index
      documents
      files
      folders
      deleted
      lag_seconds
      queue_depth
      queue_in_flight
      queue_oldest_seconds
      dlq_depth
      scan {
        execution
        status
        start_date
        stop_date
        rebuild
      }
      search {
        requests
        failures
        failure_rate
        avg_duration_ms
        zero_results
        zero_result_rate
      }
    }
  }
`;
